export function sentenceToTitleCase(sentence) {
  let listOfTitleCasedWords = sentence
    .toLowerCase()
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1));
  return listOfTitleCasedWords.join(" ");
}
